(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["parfumetics-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-collection-navigation')) {
    customElements.define('pf-collection-navigation', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.viewport = this.querySelector('[data-pf-viewport]');
        this.thumb = this.querySelector('[data-pf-thumb]');
        if (!this.viewport || !this.thumb) return;
        this.update = () => {
          const viewport = this.viewport;
          const track = this.thumb.parentElement;
          const maxScroll = viewport.scrollWidth - viewport.clientWidth;
          track.style.opacity = maxScroll > 1 ? '1' : '0';
          const width = track.clientWidth;
          if (maxScroll <= 1 || width === 0) return;
          const thumbWidth = Math.min(width, Math.max(24, viewport.clientWidth / viewport.scrollWidth * width));
          const position = Math.min(1, Math.max(0, Math.abs(viewport.scrollLeft) / maxScroll));
          const rtl = getComputedStyle(viewport).direction === 'rtl';
          this.thumb.style.width = `${thumbWidth}px`;
          this.thumb.style.transform = `translateX(${(rtl ? 1 - position : position) * (width - thumbWidth)}px)`;
        };
        this.viewport.addEventListener('scroll', this.update, { passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.viewport);
        this.observer.observe(this.viewport.firstElementChild);
        this.observer.observe(this.thumb.parentElement);
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.viewport?.removeEventListener('scroll', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parfumetics-product-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pf-product-grid')) {
  customElements.define('pf-product-grid', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.setupVibe();
      this.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('.pfpg__buy-form')) return;
        event.preventDefault();
        this.addProduct(form);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    setupVibe() {
      const toggle = this.querySelector('.pfpg__vibe-toggle');
      if (!toggle) return;
      toggle.hidden = false;
      let enabled = false;
      try { enabled = sessionStorage.getItem('pf-collection-vibe') === 'true'; } catch {}
      this.setVibe(enabled);
      toggle.addEventListener('click', () => {
        const value = toggle.getAttribute('aria-checked') !== 'true';
        try { sessionStorage.setItem('pf-collection-vibe', String(value)); } catch {}
        document.querySelectorAll('pf-product-grid').forEach(grid => {
          if (grid.querySelector('.pfpg__vibe-toggle') && grid.setVibe) grid.setVibe(value);
        });
      }, { signal: this.controller.signal });
    }
    setVibe(enabled) {
      this.dataset.vibe = String(enabled);
      this.querySelector('.pfpg__vibe-toggle')?.setAttribute('aria-checked', String(enabled));
      if (!enabled) return;
      this.querySelectorAll('template[data-vibe-image]').forEach(template => {
        const image = template.content.firstElementChild.cloneNode(true);
        const ready = () => { if (image.naturalWidth > 0) image.setAttribute('data-ready', ''); };
        image.addEventListener('load', ready, { once: true });
        template.replaceWith(image);
        if (image.complete) ready();
      });
    }
    async addProduct(form) {
      const button = form.querySelector('button');
      if (button.disabled) return;
      const feedback = form.closest('.pfpg__card').querySelector('.pfpg__feedback');
      const message = feedback.querySelector('span');
      const cartLink = feedback.querySelector('a');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      feedback.hidden = true;
      cartLink.hidden = true;
      let added = false;
      try {
        const data = new FormData(form);
        const response = await fetch(form.action + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: data.get('id'), quantity: Number(data.get('quantity')) }] })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          message.textContent = typeof error.description === 'string' ? error.description : form.dataset.error;
          return;
        }
        added = true;
        message.textContent = form.dataset.added;
        cartLink.hidden = false;
        const themeApi = typeof theme !== 'undefined' ? theme : window.theme;
        if (themeApi?.cart?.fetchTotals && themeApi.cart.updateAllHtml) {
          try {
            await themeApi.cart.fetchTotals();
            const results = await themeApi.cart.updateAllHtml(true);
            const refreshed = !Array.isArray(results) || results.every(result => result.status === 'fulfilled');
            if (refreshed && themeApi.settings?.cart_type === 'drawer' && themeApi.drawer?.open && button.isConnected) {
              themeApi.drawer.open('right', 'cart-drawer', button);
            }
          } catch {
            message.textContent = form.dataset.added;
          }
        }
      } catch {
        message.textContent = added ? form.dataset.added : form.dataset.uncertain;
        cartLink.hidden = false;
      } finally {
        feedback.hidden = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
